// Enumeration of all possible icons
// Files are stored in assets using the name.svg
export enum Icon {
  edit = 'edit',
  mail = 'mail',
  plus = 'plus',
  json = 'json'
}

/**
 * Creates the relative icon location for an icon
 */
export function iconSource(icon: Icon): string {
  return `assets/icons/${icon}.svg`;
}
